const NOTIFICATION_SOUND_URL = '/notification.mp3'

let chime: HTMLAudioElement | null = null

// Never throws. Browsers refuse audio until the page has been interacted with,
// rewinding can throw before the file has loaded, and the file may be missing.
// The toast and the flashing tab carry the news on their own.
export const playNotificationSound = () => {
  try {
    chime ??= new Audio(NOTIFICATION_SOUND_URL)
    chime.currentTime = 0
    chime.play().catch(() => {})
  } catch {
    // no sound is not worth breaking the caller
  }
}
